import {
	GET_DOCUMENT_PAGE_REQUEST,
	GET_DOCUMENT_ROW_CLICK_REQUEST,
	GET_DOCUMENT_REQUEST_SUCCESS,
	GET_DOCUMENT_REQUEST_FAILED,
	GET_DOCUMENT_REQUEST_FAILED_CLEAR,
	UPDATE_DOCUMENT_MODAL_COMMENTS,
	GET_FILE_REQUEST_SUCCESS,
	GET_FILE_REQUEST_FAILED,
	GET_FILE_REQUEST_FAILED_CLEAR,
	GET_FILE_ROW_CLICK_REQUEST,
	GET_FILE_PAGE_REQUEST,
	GET_FILE_PAGE_REQUEST_SUCCESS,
	GET_FILE_PAGE_REQUEST_FAILED,
	GET_FILE_PAGE_REQUEST_FAILED_CLEAR,
	RESET_PAGE_VIEWER,
	GET_PAGE_NUMBER_BASED_ON_DOC_ID,
	GET_PAGE_NUMBER_BASED_ON_DOC_ID_SUCCESS,
	GET_PAGE_NUMBER_BASED_ON_DOC_ID_FAILED,
	GET_PAGE_NUMBER_BASED_ON_DOC_ID_RESET,
	UPDATE_PAGE_NUMBER_FOR_CURRENT_DOCUMENT,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_SUCCESS,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_FAILED,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_RESET,
	UPDATE_DOCUMENT_MODAL_REVIEW,
} from "../types"

export const getDocumentRequestByPage = (data) => ({
	type: GET_DOCUMENT_PAGE_REQUEST,
	payload: data,
})

export const getDocumentRowClickRequest = (data) => ({
	type: GET_DOCUMENT_ROW_CLICK_REQUEST,
	payload: data,
})

export const getDocumentRequestSuccess = (data) => ({
	type: GET_DOCUMENT_REQUEST_SUCCESS,
	payload: data,
})

export const getDocumentRequestFailed = (data) => ({
	type: GET_DOCUMENT_REQUEST_FAILED,
	payload: data,
})

export const getDocumentRequestFailedClear = (data) => ({
	type: GET_DOCUMENT_REQUEST_FAILED_CLEAR,
	payload: data,
})

export const updateDocumentModalComments = (data) => ({
	type: UPDATE_DOCUMENT_MODAL_COMMENTS,
	payload: data,
})

export const updateDocumentModalReview = (data) => ({
	type: UPDATE_DOCUMENT_MODAL_REVIEW,
	payload: data,
})

export const getFileRequestSuccess = (data) => ({
	type: GET_FILE_REQUEST_SUCCESS,
	payload: data,
})

export const getFileRequestFailed = (data) => ({
	type: GET_FILE_REQUEST_FAILED,
	payload: data,
})

export const getFileRequestFailedClear = (data) => ({
	type: GET_FILE_REQUEST_FAILED_CLEAR,
	payload: data,
})

export const getFileRowClickRequest = (data) => ({
	type: GET_FILE_ROW_CLICK_REQUEST,
	payload: data,
})

export const getFileRequestByPage = (data) => ({
	type: GET_FILE_PAGE_REQUEST,
	payload: data,
})

export const getFileRequestByPageSuccess = (data) => ({
	type: GET_FILE_PAGE_REQUEST_SUCCESS,
	payload: data,
})

export const getFileRequestByPageFailed = (data) => ({
	type: GET_FILE_PAGE_REQUEST_FAILED,
	payload: data,
})

export const getFileRequestByPageFailedClear = (data) => ({
	type: GET_FILE_PAGE_REQUEST_FAILED_CLEAR,
	payload: data,
})

export const resetPageViewerData = (data) => ({
	type: RESET_PAGE_VIEWER,
	payload: {},
})

export const getPageNumberBasedOnFileIdRequest = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_DOC_ID,
	payload: data,
})

export const getPageNumberBasedOnFileIdSuccess = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_DOC_ID_SUCCESS,
	payload: data,
})

export const getPageNumberBasedOnFileIdFailed = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_DOC_ID_FAILED,
	payload: data,
})

export const getPageNumberBasedOnHighlightTextRequest = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT,
	payload: data,
})

export const getPageNumberBasedOnHighlightTextSuccess = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_SUCCESS,
	payload: data,
})

export const getPageNumberBasedOnHighlightTextFailed = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_FAILED,
	payload: data,
})

export const getPageNumberBasedOnHighlightTextReset = (data) => ({
	type: GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_RESET,
	payload: data,
})

export const updatePageNumberForCurrentDocument = (data) => ({
	type: UPDATE_PAGE_NUMBER_FOR_CURRENT_DOCUMENT,
	payload: data,
})

export const documentsActions = {
	getDocumentRequestByPage,
	getDocumentRowClickRequest,
	getDocumentRequestSuccess,
	getDocumentRequestFailed,
	getDocumentRequestFailedClear,
	updateDocumentModalComments,
	getFileRequestSuccess,
	getFileRequestFailed,
	getFileRequestFailedClear,
	getFileRowClickRequest,
	getFileRequestByPage,
	getFileRequestByPageSuccess,
	getFileRequestByPageFailed,
	getFileRequestByPageFailedClear,
	getPageNumberBasedOnFileIdRequest,
	getPageNumberBasedOnFileIdSuccess,
	getPageNumberBasedOnFileIdFailed,
	updatePageNumberForCurrentDocument,
	getPageNumberBasedOnHighlightTextRequest,
	getPageNumberBasedOnHighlightTextSuccess,
	getPageNumberBasedOnHighlightTextFailed,
	getPageNumberBasedOnHighlightTextReset,
}
